import type { SerializedStyles } from '@emotion/react';
import type { InputHTMLAttributes, ReactNode } from 'react';

export type InputTheme = 'light' | 'transparent';

export type InputVariant = 'regular' | 'new';
export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  dropdown?: ReactNode;
  wrapperCss?: SerializedStyles;
  textarea?: boolean;
  theme?: InputTheme;
  textDisabled?: boolean;
  helperText?: ReactNode;
  hasError?: boolean;
  hideNumberArrows?: boolean;
  mobileStyleDropdown?: boolean;
  relativeDropdown?: boolean;
  variant?: InputVariant;
}
